import React from 'react';
import { useParams } from 'react-router-dom';
import { PageTemplateSpinner } from '@sierralabs/core-ui';
import { useFindFormTemplate } from '../FormTemplate.hooks';
export const FormSchemaTab = () => {
    const { formTemplateId = 0 } = useParams();
    const { formTemplate, isLoading } = useFindFormTemplate(+formTemplateId, true);
    return isLoading || !(formTemplate === null || formTemplate === void 0 ? void 0 : formTemplate.entity) ? (React.createElement(PageTemplateSpinner, null)) : (React.createElement(React.Fragment, null));
};
export default FormSchemaTab;
//# sourceMappingURL=FormSchemaTab.js.map